<template>
  <div class="store">
    <search @getKeyword="setKeyword"></search>
    <van-row class="container">
      <van-tabs v-model="activeName" animated sticky offset-top="54">
        <van-tab title="店铺首页" name="0">
          <van-row class="banner">
            <van-col span='24'>
              <van-swipe :autoplay="3000" v-if="banner.length > 0">
                <van-swipe-item v-for="(image, index) in banner" :key="index">
                  <img v-lazy="image" class="image" />
                </van-swipe-item>
              </van-swipe>
              <van-swipe :autoplay="3000" v-else>
                <van-swipe-item v-for="(image, index) in images" :key="index">
                  <img v-lazy="image" class="image" />
                </van-swipe-item>
              </van-swipe>
            </van-col>
          </van-row>
          <van-row class="info">
            <van-col span=24 class="info-col">
              <span class="title">店铺名称: </span>
              <span class="content">{{store.store_name}}</span>
            </van-col>
            <van-col span=24 class="info-col">
              <span class="title">店铺地址: </span>
              <span class="content">{{store.address}}</span>
            </van-col>
            <van-col span=24 class="info-col">
              <span class="title">店铺电话: </span>
              <span class="content">
                {{store.tel}}, {{store.contact}}
              </span>
            </van-col>
            <van-col span=24 class="info-col" style="display: inline-block;">
              <span class="title">主营: </span>
              <van-notice-bar :text="store.salecate" class="notice-bar" />
            </van-col>
          </van-row>
          <van-row class="recommend-pro">
            <best-product :productList="productList"></best-product>
          </van-row>
        </van-tab>
        <van-tab title="店铺商品" name="1">
          <product-list :keyword="keyword" :store_id="store_id"></product-list>
        </van-tab>
      </van-tabs>
    </van-row>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Search from '@components/Search';
  import BestProduct from '@components/BestProduct'
  import ProductList from '@components/ProductList'
  import {
    shopIndex
  } from '@/api/store.js'
  import {
    Swipe,
    SwipeItem,
    Lazyload,
    Row,
    Col,
    Button,
    Tab,
    Tabs,
    Icon,
    Divider,
    SwipeCell,
    Card,
    NoticeBar
  } from 'vant';
  Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(Row).use(Col).use(Button).use(Tab).use(Tabs).use(Icon).use(Divider)
    .use(Card).use(SwipeCell).use(NoticeBar)
  export default {
    name: 'StoreDetail',
    components: {
      Search,
      BestProduct,
      ProductList
    },
    data() {
      return {
        keyword: '',
        store_id: null,
        store: {},
        banner: [],
        value: '',
        productList: [],
        activeName: '0',
        images: [
          'https://img.yzcdn.cn/vant/apple-1.jpg',
          'https://img.yzcdn.cn/vant/apple-2.jpg',
        ],
      }
    },

    methods: {
      setKeyword(value) {
        this.keyword = value
        // console.log(this.keyword, 'keyword')
        this.activeName = '1'
      },
      getStoreDetail() {
        var that = this

        // localStorage.setItem('store_id', this.$route.params.id)
        shopIndex({
          id: this.store_id
        }).then((res) => {
          // console.log(res, 'store_detail')
          if (res && res.msg == 'ok') {
            that.store = res.data.shop
            // console.log(that.store, 'that.store')
            that.banner = that.store.banner
            that.productList = res.data.recommend_list
          }
        })
      }
    },
    mounted() {
      this.store_id = this.$route.params.id
      this.getStoreDetail()
    }
  }
</script>

<style scoped>
  .store {
    background-color: #fff;
  }

  .store .container {
    background-color: #F2F3F4;
  }

  .store .container .info {
    background-color: #fff;
  }

  .store .container .info .info-col,
  .recommend-pro .info-col {
    height: 0.9rem;
    line-height: 0.9rem;
    padding: 0 0.1rem;
    border-bottom: 1px solid #E5E7E9;
  }

  .store .container .info span,
  .recommend-pro .info-col .title {
    color: #666;
    font-size: 0.9em;
  }

  .store .banner {
    z-index: -1
  }

  .store .banner .image {
    width: 100%;
    height: 2.5rem;
  }

  .collect-button {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }

  .recommend-pro {
    margin-top: 0.2rem;
    background-color: #fff;
  }

  .recommend-pro .info-col .title {
    color: #ff2150;
    margin-left: 0.2em
  }

  .recommend-pro .info-col .icon {
    padding: 0.1em;
  }

  .notice-bar {
    float: right;
    width: 90%;
    background: #fff;
    color: #666;
    padding: 0.4em 0 0 0;
    font-size: 0.9em;
  }
</style>
